import { render } from "./TabWithTable.vue?vue&type=template&id=603a9a16&scoped=true"
import script from "./TabWithTable.vue?vue&type=script&lang=js"
export * from "./TabWithTable.vue?vue&type=script&lang=js"

import "./TabWithTable.vue?vue&type=style&index=0&id=603a9a16&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603a9a16"]])

export default __exports__